import axios from "axios";
import { API_PERU_URL, API_PERU_TOKEN } from "../../config/configEnvs";
import { toast } from "react-toastify";

export const FetchRucPeru = async ({ ruc, type = "ruc" }) => {
  try {
    if (!ruc || ruc.length !== 11) {
      toast.error("RUC inválido");
      return false;
    }

    const response = await axios.post(
      `${API_PERU_URL}${type}`,
      { ruc },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_PERU_TOKEN}`,
        },
      }
    );

    if (!response.data?.success) {
      toast.error("No se encontró el RUC");
      return false;
    }

    if (type === "ruc") {
      const payload = response.data?.data;
      if (!payload?.nombre_o_razon_social) {
        toast.error("No se encontró el RUC");
        return false;
      }
      return {
        empresa: payload.nombre_o_razon_social,
        direccion: payload.direccion_completa || payload.direccion || "",
      };
    }

    const data = response?.data?.data?.[0] || {};
    if (!data?.nombre) {
      toast.error("No se encontró el representante legal");
      return false;
    }
    return {
      docType: data.tipo_de_documento,
      dni: data.numero_de_documento,
      nombre: data.nombre,
      cargo: data.cargo,
    };
  } catch (error) {
    toast.error("Error al obtener el RUC");
    return false;
  }
};
